import React, { useState, useEffect, useContext } from "react";
import { styled, useTheme } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { makeStyles } from "@mui/styles";
import Navigation from "../navigation/Navigation";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import ListItem from "@mui/material/ListItem";
import Skeleton from "@mui/material/Skeleton";
import { getDataWithToken } from "../../services/GetDataService";
import { Container, Grid, Paper } from "@mui/material";
import { useSnackbar } from "notistack";
import { postDataWithToken } from "../../services/PostDataService";
import Header from "../../header/Header";
import Navbar from "../../header/Navbar";
import Footer from "../../footer/Footer";
const useStyles = makeStyles((theme) => ({
  linkStyle: {
    textDecoration: "none",
    color: "#858e9b",
  },
  menuItem: {
    // color: "#fff",
    padding: "6px 16px !important",

    "& span": {
      fontSize: "14px",
      [theme.breakpoints.down("xl")]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
      },
    },
    ["& .MuiListItemIcon-root"]: {
      minWidth: "30px",
    },
    ["& .MuiSvgIcon-root"]: {
      position: "relative",
      top: "-2px",
      color: "#858e9b",
      fontSize: "20px",
      [theme.breakpoints.down("md")]: {
        fontSize: "10px",
      },
    },
  },
  menuItemActive: {
    // color: "rgba(15, 188, 249,1.0) !important",
    color: "rgba(255,255,255,0.7) !important",
    // background:
    //   "linear-gradient(56deg, rgba(232,9,43,.5) 0%, rgba(232,9,43,.2) 100%) !important",
    background: "rgb(255,255,255,0.2) !important",
    borderRadius: "10px !important",
    ["& .MuiSvgIcon-root"]: {
      color: "rgba(255,255,255,0.7) !important",
    },
    ["& svg path"]: {
      fill: "rgba(255,255,255,0.7) !important",
    },
  },
  menuSubItem: {
    padding: "6px 32px 2px 38px !important",
    "& span": {
      // fontSize: "16px",
      fontSize: "13px",
      [theme.breakpoints.down("xl")]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "10px",
      },
    },
    ["& .MuiListItemIcon-root"]: {
      minWidth: "30px",
    },
    ["& .MuiSvgIcon-root"]: {
      color: "#858e9b",
      fontSize: "20px",
      [theme.breakpoints.down("md")]: {
        fontSize: "10px",
      },
    },
  },

  MuiDrawer: {
    backgroundColor: "#353b48 !important",
    color: "#858e9b !important",
    // paddingRight: "7px",
    // paddingLeft: "7px",
  },
}));

const drawerWidth = 250;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function Layout({ toggleTheme }) {
  const classes = useStyles();
  let navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  let pathname = useLocation().pathname;
  const [logoutLoading, setLogoutLoading] = useState(false);
  const { login, admin_panel_user, logout } = useContext(AuthContext);
  // console.log("pathname", pathname);

  const theme = useTheme();
  const [kycRequestOpen, setKycRequestOpen] = useState(false);
  const [onboardingOpen, setOnboardingOpen] = useState(false);
  const [manageRolesOpen, setManageRolesOpen] = useState(false);
  const [manageAccessOpen, setManageAccessOpen] = useState(false);
  const [bankingLogOpen, setBankingLogOpen] = useState(false);
  const [rollPermission, setRollPermission] = useState([]);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const time = parseInt(1000 * 60 * 120);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuCollaseOpen, setMenuCollaseOpen] = useState("");
  const menuOpen = Boolean(anchorEl);

  const navigateRoutes = (routeName) => {
    navigate(routeName, { replace: true });
  };
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const onLogoutTokenSubmit = async () => {
    setLogoutLoading(true);
    // try {
    const formdata = new FormData();
    formdata.append("token", admin_panel_user.token);

    let response = await postDataWithToken(
      "api/logout",
      formdata,
      admin_panel_user,
      logout
    );
    //  await axios({
    //   url: "api/logout",
    //   method: "post",
    //   data: formdata,
    //   headers: {
    //     Authorization: `Bearer ${admin_panel_user.token}`,
    //   },
    // });

    if (response.status === 200) {
      // handleSnakbarOpen(response.data.messages.toString(), "success");
      fnLogout();
      handleClose();
    } else {
      handleSnakbarOpen(response.data.messages.toString(), "error");
    }
    // } catch (error) {
    //   console.log("error", error);
    //   setLogoutLoading(false);
    //   handleSnakbarOpen(error.response.data.messages.toString(), "error");
    // }
    setLogoutLoading(false);
  };
  const fnLogout = () => {
    logout();
    setRollPermission([]);
    navigate("/");
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const withoutLayout = ["/", "/register", "/forgot-password", "/reset-password", "/verify"];

  let transactionstPathnameCheck = pathname.includes("transactions");
  const kybRequesttPathnameCheck = () => {
    if (pathname.includes("/kyb-request")) {
      return true;
    } else if (pathname.includes("/kyb-details/")) {
      return true;
    } else {
      return false;
    }
  };
  const kycRequesttPathnameCheck = () => {
    if (pathname.includes("/kyc-request")) {
      return true;
    } else if (pathname.includes("/kyc-detail/")) {
      return true;
    } else {
      return false;
    }
  };
  const usertPathnameCheck = () => {
    if (pathname.includes("/search-user")) {
      return true;
    } else if (pathname.includes("/user/")) {
      return true;
    } else {
      return false;
    }
  };

  const storePathnameCheck = () => {
    if (pathname.includes("/store-management")) {
      return true;
    } else if (pathname.includes("/store-detail/")) {
      return true;
    } else if (pathname.includes("/update-store-detail/")) {
      return true;
    } else {
      return false;
    }
  };

  let showOnboardingRequest = () => {
    if (
      rollPermission?.includes("KYC request list") ||
      rollPermission?.includes("KYB request list")
    ) {
      return true;
    } else {
      return false;
    }
  };

  let showManageRoles = () => {
    if (
      rollPermission?.includes("Manage role") ||
      rollPermission?.includes("View role")
    ) {
      return true;
    } else {
      return false;
    }
  };
  let showManageAccess = () => {
    if (
      rollPermission?.includes("Create user") ||
      rollPermission?.includes("View user")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const pageLoading = () => {
    return (
      <List>
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
          <ListItem button key={index}>
            <Skeleton
              variant="rectangular"
              style={{ width: "100%" }}
              height={30}
            />
          </ListItem>
        ))}
      </List>
    );
  };

  const getData = async () => {
    if (admin_panel_user.token) {
      // setLoading(true);

      let userPermissions = await getDataWithToken(
        "api/user-permissions",
        admin_panel_user,
        logout
      );

      if (userPermissions.data.code === 200) {
        setRollPermission(userPermissions.data.data.permissions);
      } else {
        setMessage(userPermissions.data.messages.toString());

        // setLoading(false);
      }
      // setLoading(false);
    }
  };
  useEffect(() => {
    // getData();
  }, []);

  if (withoutLayout.includes(pathname)) {
    return (
      <Navigation
      // rollPermission={rollPermission}
      // setRollPermission={setRollPermission}
      // openLoadingDialog={openLoadingDialog}
      // setOpenLoadingDialog={setOpenLoadingDialog}
      />
    );
  } else if (!admin_panel_user.token) {
    return (
      <Navigation
      // rollPermission={rollPermission}
      // setRollPermission={setRollPermission}
      // openLoadingDialog={openLoadingDialog}
      // setOpenLoadingDialog={setOpenLoadingDialog}
      />
    );
  } else {
    return (
      <>
        <Grid
          container
          direction="column"
          // alignItems="center"
          justifyContent="space-between"
          sx={{ minHeight: "100vh" }}
        >
          <Grid item xs={12}>
            <Paper
              sx={{
                padding: "0px",
                position: "sticky",
                top: "0px",
                zIndex: 1000,
              }}
            >
              <Container maxWidth="xl">
                <Header toggleTheme={toggleTheme} />
              </Container>
              <Divider />
              <Container maxWidth="xl">
                <Navbar />
              </Container>
            </Paper>
            <Container maxWidth="xl" sx={{ mt: 3 }}>
              <Navigation toggleTheme={toggleTheme} />
            </Container>
          </Grid>
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Divider />
            <Footer />
          </Grid>
        </Grid>
      </>
    );
  }
}
